module.exports = __webpack_public_path__ + "static/media/opium.a8570ced.jpg";